<template>
    <div class="board_card template4">
        <!--  Due to mobile and pc different end width ，board_card The width is passed in by the parent component   pass style -->
        <div class="top">
            <div class="amount">{{ params.data }}</div>
            <div
                v-show="hasRecentSold"
                class="tendency"
                :class="[
                    { up: params.status === 1, down: params.status === -1 },
                    params.class ? params.class : ''
                ]"
            >
                <!--  more than the  0  or   less than  0 -->
                <div
                    class="tendency_content"
                    v-if="
                        (params.status === 1 || params.status === -1) &&
                            !params.dataComing
                    "
                >
                    <span
                        class="iconfont"
                        :class="{
                            'icon-trend-up': params.status > 0,
                            'icon-trend-down': params.status < 0
                        }"
                    ></span>
                    <span class="num">{{ params.changeNum }}</span>
                </div>
                <!--  equal  0 -->
                <div
                    class="no_data"
                    v-else-if="params.status === 0 && !params.dataComing"
                >
                    <span>{{ params.changeNum }}</span>
                </div>
                <!-- 30-60 No property sold  -->
                <div class="no_data" v-else>
                    <span>{{ params.dataComing ? '' : '-' }}</span>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="name">{{ params.title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'board-card',
    props: {
        params: Object,
        hasRecentSold: Boolean
    }
};
</script>

<style lang="scss">
.board_card.template4 {
    position: relative;
    /* background: #fff; */
    background: #f5f6fa;
    padding: 46px 30px;
    font-family: var(--font-normal);
    line-height: 1;
    &::before {
        content: '';
        width: 100%;
        height: 6px;
        background-color: var(--color-theme);
        position: absolute;
        left: 0;
        top: 0;
    }
    .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .amount {
            font-size: 32px;
            font-weight: 900;
            color: var(--mg-title-color);
        }
        .tendency {
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;
            .iconfont {
                font-size: 10px;
            }
            &.up {
                color: #29cb97;
                &.diff-color {
                    color: #ff5661;
                }
            }
            &.down {
                color: #ff5661;
                &.diff-color {
                    color: #29cb97;
                }
            }
            .tendency_content {
                display: flex;
                align-items: center;
            }
        }
    }
    .bottom {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 500;
        color: var(--color-label);
    }
    .no_data {
        color: var(--color-label);
    }
}
</style>
